// 會員路由
const name = '商家'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/sellers',
  component: Layout,
  children: [
    {
      path: 'storemanager/marketingdistributor',
      name: `店鋪列表`,
      component: () => import('@/view/mall/marketing/distributor'),
      children: [
        {
          path: 'editor/:itemId?',
          // component: () => import('@/view/mall/marketing/distributor_editor')
          component: () => import('@/view/merchant/store')
        },
        {
          path: 'template/:distributor_id?',
          component: () => import('@/view/mall/marketing/distributor_template')
        },
        {
          path: 'details/:id?',
          component: () => import('@/view/mall/marketing/distributor_details')
        },
        {
          path: 'wxpaysetting',
          component: () => import('@/view/mall/marketing/distributor_wxpaysetting')
        },
        {
          path: 'alipaysetting',
          component: () => import('@/view/mall/marketing/distributor_alipaysetting')
        }
      ]
    },
    {
      path: 'storemanager/list',
      name: `商家列表`,
      component: () => import('@/view/mall/marketing/merchantList/index'),
      children: [
        {
          path: 'editor',
          component: () => import('@/view/mall/marketing/merchantList/editor')
        }
      ]
    },
    {
      path: 'storemanager/distributortags',
      name: `商家標籤`,
      component: () => import('@/view/mall/marketing/distributortags')
    },
    {
      path: 'storemanager/distributoraftersalesaddress',
      name: `售後地址`,
      component: () => import('@/view/mall/marketing/distributorAftersalesAddress')
    },
    {
      path: 'storemanager/application',
      name: `入駐審核`,
      component: () => import('@/view/mall/marketing/merchantVerify'),
      children: [
        {
          path: 'verify',
          component: () => import('@/view/mall/marketing/merchantVerify/verify')
        }
      ]
    },
    {
      path: 'storemanager/setting',
      name: '商家設置',
      component: () => import('@/view/mall/marketing/setting')
    }
  ]
}
